{
  "app": {
    "name": "POSS",
    "legend": "Pacific One Stop Shop"
  },
  "dashboard": {
    "statistics": "Statistikalar",
    "jurisdictions": "Yurisdiksiyalar",
    "pendingDisbursements": "Gözləyən ödənişlər",
    "payments": "Ödənişlər",
    "taxpayers": "Vergi ödəyiciləri",
    "firstPayment": "İlk ödəniş",
    "lastPayment": "Son ödəniş"
  },
  "config": {
    "tin": "PIN",
    "tinLegend": "POSS Identification Number"
  },
  "menu": {
    "label": {
      "security": "Təhlükəsizlik",
      "users": "İstifadəçilər",
      "apikey": "Açar",
      "twoFactorAuthentication": "İki Faktor autentifikasiyası",
      "configuration": "Quraşdırma",
      "notifications-application": "Bildirişlər Tətbiqi",
      "notifications-security": "Təhlükəsizlik haqqında bildirişlər",
      "environment-application": "Ətraf mühit tətbiqi",
      "environment-security": "Ətraf Mühit Təhlükəsizliyi",
      "operations": "Gedişlər",
      "economy-activity": "İqtisadiyyatın fəaliyyəti",
      "catalog": "Kataloq növü",
      "taxpayer-fields": "Vergi ödəyicilərinin sahələri",
      "taxes": "Vergilər",
      "manage-tax": "Vergiləri İdarə Et"
    }
  },
  "administration-user": {
    "title": {
      "page": "İstifadəçilər",
      "page-taxpayer": "Vergi ödəyiciləri",
      "page-disable-tfa": "İki Faktorun Autentifikasiyası (2FA)",
      "activation-link-confirmation": "Aktivləşdirmə keçidini təsdiqlə"
    },
    "label": {
      "userName": "İstifadəçi Adı",
      "department": "Şöbə",
      "roles": "Rollar",
      "general-information": "Ümumi məlumat",
      "user": "Yeni istifadəçi",
      "edit-user": "İstifadəçini düzəlt",
      "disabled": "Söndür",
      "email-confirmed": "E-poçt təsdiqlənib",
      "invitation-sent-at": "Dəvət göndərilib",
      "invitation-not-sent": "Göndərilməyib",
      "locale": "Üstünlük verilmiş dil",
      "disable": "Fəallaşdır",
      "enable": "Fəallaşdır",
      "cancel": "Ləğv etmək",
      "return": "Geri"
    },
    "button": {
      "send-activation-link": "Aktivləşdirmə keçidini göndər",
      "resend-activation-link": "Aktivləşdirmə keçidini yenidən göndər"
    },
    "validations": {
      "userName": "İstifadəçi Adı tələb olunur"
    },
    "messages": {
      "disableTitle": "İstifadəçini bağla",
      "confirmDisable": "Bu istifadəçini qeyri-fəal etmək istədiyinizdən əminsiniz?",
      "confirmEnable": "Bu istifadəçini fəal etmək istədiyinizdən əminsiniz?",
      "savedSucessfully": "Müvəffəqiyyətlə qeyd edilib",
      "enableTitle": "İstifadəçini fəallaşdır",
      "error": "Xəta",
      "confirmDisableTfaTitle": "2FA-nı qeyri-fəallaşdır",
      "confirmDisableTfa": "Əminsinizmi ki, \"{0}\" istifadəçisinə iki faktor üzrə autentifikasiyanı qeyri-fəal etmək istəyirsiniz?",
      "tfaDisabledSucessfully": "İki faktor üzrə autentifikasiya müvəffəqiyyətlə həyata keçirilir",
      "activation-link-sent": "Aktivləşdirmə keçidi göndərildi",
      "confirm-send-activation-link": "Bu istifadəçiyə aktivləşdirmə keçidini göndərmək istədiyinizə əminsiniz?",
      "confirm-resend-activation-link": "Bu istifadəçiyə aktivləşdirmə keçidini yenidən göndərmək istədiyinizə əminsiniz?"
    }
  },
  "user-profile": {
    "title": {
      "page": "İstifadəçi Profili",
      "change-password": "Şifrəni Dəyiş"
    },
    "label": {
      "userName": "İstifadəçi Adı",
      "name": "Tam Adı",
      "email": "E-poçt",
      "locale": "Üstünlük verilmiş dil",
      "currentPassword": "Hazırkı şifrə",
      "newPassword": "Şifrə",
      "repeatPassword": "Şifrəni təkrarla",
      "change-password": "Şifrəni Dəyiş",
      "password": "parol"
    },
    "message": {
      "password-changed": "Şifrə uğurla dəyişdirildi",
      "profile-updated": "Profil uğurla yeniləndi. Dəyişiklikləri görmək üçün logout edilməlidir",
      "password": "Hesabınızı təhlükəsiz saxlamaq üçün hesab parolunuzu yeniləyin"
    }
  },
  "inbox-notifications": {
    "title": {
      "inbox": "Gələnlər Qutusu"
    },
    "label": {
      "message": "İsmarış:",
      "messages": "İsmarışlar",
      "read": "Oxu",
      "inboxDate": "Tarix",
      "ok": "Yaxşı",
      "no": "XEYR"
    }
  },
  "collections": {
    "label": {
      "maximumNumberOfTaxpayers": "Vergi ödəyicilərinin maksimal sayı",
      "durationProcess": "Davametmə günləri",
      "descriptionProcess": "İzah",
      "selectedTaxpayers": "Seçili",
      "excludedTaxpayers": "Kənarlaşdırılmış",
      "debtDetail": "Borc detallarına bax",
      "lastTaxreturn": "Son verginin qaytarılması",
      "lastPayment": "Son ödəniş",
      "excluded": "Kənarlaşdırılmış",
      "debtOriginal": "Orijinal borc",
      "debtFinal": "Son borc",
      "currentDebt": "Cari borc",
      "code": "Tanıt",
      "taxpayer": "Vergi ödəyicisi",
      "start": "Başla",
      "end": "Bitiş",
      "newCommunication": "Yeni kommunikasiya",
      "typeCommunication": "Kommunikasiya kanalı",
      "saveCommunication": "Ünsiyyəti qeyd et",
      "communicationChannelPhone": "Telefon",
      "communicationChannelMail": "Poçt",
      "process": "Gedişat",
      "startProcess": "Gedişat başladı",
      "recoveredDebt": "Borc bərpa olundu",
      "endProcess": "Gedişat",
      "timeElapsed": "Orta cavab",
      "countProcess": "Proseslər",
      "countEndedProcess": "Qurtardı",
      "countInProgressProcess": "Gedişatda",
      "countTaxpayerProcess": "Vergi ödəyiciləri",
      "unpaid": "Ödənişsiz",
      "noCommunications": "Rabitə yoxdur"
    },
    "title": {
      "detailCollection": "Ödəniş haqqında məlumat",
      "newProcessCollection": "Yeni toplama prosesi",
      "selectionTaxpayerProcess": "Vergi ödəyicilərinin seçilməsi",
      "indicators": "Göstəricilər",
      "taxreturnAndPayments": "Vergilərin qaytarılması və ödənilməsi",
      "communications": "Rabitə",
      "processCollection": "Toplama prosesləri",
      "StatisticQuery": "Konsultulyasiya dövrü",
      "StatisticQueryResult": "Nəticələr"
    },
    "status": {
      "started": "Başladı",
      "ended": "Qurtardı"
    },
    "messages": {
      "newProcessCreated": "[startDate] -də başlayan və [endDate] -də bitən [limit] vergi ödəyiciləri ilə yeni yığım prosesi yaradıldı"
    }
  },
  "formDefinition": {
    "label": {
      "reconecting": "Yenidən qurulur",
      "reconected": "Yenidən bərpa edildi"
    }
  },
  "common": {
    "label": {
      "valueType": "Qiymət növü",
      "theme": "Tema",
      "feedback": "Geribildirim",
      "logout": "Logout",
      "print": "Çap Et",
      "phoneNumberArea": "Ərazi",
      "newRecord": "Yeni",
      "editRecord": "Yenilə",
      "current-user": "Hazırkı istifadəçi",
      "user-profile": "İstifadəçi profili",
      "name": "Ad",
      "search": "Axtar",
      "clean": "Təmiz",
      "create": "Yarat",
      "ok": "Yaxşı",
      "next": "Sonrakı",
      "cancel": "Ləğv etmək",
      "back": "Geri",
      "edit": "_Düzəlt",
      "actions": "Hərəkət",
      "selectAction": "Fəaliyyət seçin",
      "send": "Göndər",
      "close": "Bağla",
      "add": "Əlavə Et",
      "email": "E-poçt",
      "phoneNumber": "Telefon Nömrəsi",
      "id": "Id",
      "password": "Şifrə",
      "state": "Söndür",
      "translation": "Tərcümə",
      "language": "Dil",
      "value": "Qiymət",
      "translatable": "Translatable",
      "politicalDivision": "Siyasi parçalanma",
      "department": "Şöbə/Provice/Dövlət",
      "city": "Şəhər",
      "zipCode": "Indeks",
      "cellPhone": "Mobil telefon",
      "personType": "Şəxs növü",
      "businessName": "İş adı",
      "taxpayerName": "Tam Adı və ya İş Adı",
      "tradeName": "Ticarət adı",
      "address": "Ünvan",
      "country": "Ölkə",
      "localization": "Yerliləşdirmə",
      "website": "Veb Sayt",
      "fileSearch": "Fayl axtar",
      "fileRequirements": "PDF · Maks. 9,6 MB",
      "fileUploading": "Yüklənir...",
      "fileUploaded": "Yükləndi",
      "fileUploadError": "Fayl yüklənə bilmədi",
      "fileSelect": "Seçin",
      "fileReplace": "Əvəz edin",
      "fileRemove": "Sil",
      "fileRemoving": "Silinir...",
      "fileRemoveError": "Fayl silinə bilmədi",
      "fileUpload": "Fayl yüklə",
      "fileDownload": "Faylı yüklə",
      "noFileSelected": "Seçili fayl yoxdur",
      "dateFrom": "Tarix",
      "dateTo": "Tarix",
      "noFound": "Heç bir nəticə yoxdur",
      "taxReturnCurrency": "Taxreturn Döviz",
      "page-showing": "Göstər",
      "page-to": "to",
      "page-of": "of",
      "page-entries": "Girişlər",
      "loading": "Yüklənir...",
      "error": "Xəta",
      "unableToLoad": "Məlumatları yükləmək mümkün olmadı. Zəhmət olmasa yenidən cəhd edin.",
      "retry": "Yenidən cəhd edin",
      "currency": "Pul vahidi",
      "paymentMethod": "Ödəniş üsulu",
      "attachment": "Ilişdir",
      "paymentReference": "Ödəniş referenti",
      "supportDocument": "Dayaq sokun",
      "payment": "Ödəniş",
      "backToHome": "Evə qayıt",
      "createdBy": "Tərəfindən yaradılıb",
      "bank": "Bank",
      "bankInformation": "Bank məlumatı",
      "excel": "Excel",
      "days": {
        "monday": "Mo",
        "tuesday": "Tu",
        "wednesday": "Biz",
        "thursday": "Th",
        "friday": "Fr",
        "saturday": "Sa",
        "sunday": "Su"
      },
      "months": {
        "january": "Yanvar",
        "february": "Fevral",
        "march": "Mart",
        "april": "Aprel",
        "may": "May",
        "june": "İyun",
        "july": "İyul",
        "august": "Avqust",
        "september": "Sentyabr",
        "october": "Oktyabr",
        "november": "Noyabr",
        "december": "Dekabr"
      },
      "type": "Növ",
      "numeric": "Numizmatika",
      "date": "Tarix",
      "list": "Siyahı",
      "text": "Mətn",
      "header": "Başlıq",
      "description": "İzah",
      "ommited": "Qeyd edildi",
      "all": "Hamısı",
      "see": "Göstər",
      "filters": "Filtrlər"
    },
    "descriptions": {
      "taxReturnCurrency": "Taxreturns üçün istifadə edilən pul vahidi",
      "can-access": "Daxil ola bilər",
      "contactTaxIdNumber-tax": "Əlaqə vergisinin identifikasiya nömrəsi"
    },
    "button": {
      "add": "Əlavə Et",
      "edit": "_Düzəlt",
      "find": "Axtar",
      "cancel": "Ləğv etmək",
      "delete": "Sil",
      "save": "Qeyd Et",
      "clean": "Təmizlə",
      "new": "Yeni",
      "show": "Göstər",
      "download": "Endir",
      "file": "Ilişdir",
      "previous": "Əvvəlki",
      "next": "Sonrakı",
      "send": "Göndər",
      "translate": "Tərcümə əlavə et",
      "return": "Qayıt",
      "continue": "Davam Et",
      "newVersion": "Yeni versiya"
    },
    "dialog": {
      "dialog-error": "Səhvlər",
      "table-title-header": "İsmarışlar",
      "warning-title": "Diqqət"
    },
    "messages": {
      "error-500": "Vericidə xəta baş verdi, zəhmət olmasa administratorla əlaqə saxlayın.",
      "fileUpload": "Fayl uğurla yükləndi",
      "savedSucessfully": "Müvəffəqiyyətlə qeyd edilib",
      "deletedSucessfully": "Müvəffəqiyyətlə silindi",
      "pleaseWait": "Xahiş edirəm gözləyin",
      "nofileContent": "Fayl məzmunu yoxdur",
      "errorMessageSystem": "Kataloqda '${code}' parametri tapılmadı",
      "warningInactiveSession": "Diqqət! Bir müddət ərzində heç bir fəaliyyət aşkar edilməyib. Hələlik heç bir fəaliyyət aşkar olunmasa, iclas 1 dəqiqə ərzində bağlanacaq",
      "sessionIdleCountdown": "Sessiyanız {{count}} saniyə sonra bağlanacaq.",
      "closingSession": "İclası Bağla ...",
      "confirm": "Əminsinizmi ki, bu hərəkəti etmək istəyirsiniz?",
      "uploadProcessing": "Məlumat yüklənib və işlənilir, işlənməni bitirdikdən sonra sizə xəbər veriləcək.",
      "messageSent": "İsmarış müvəffəqiyyətlə göndərildi"
    },
    "validations": {
      "nameRequired": "Sahə Adı tələb olunur",
      "fieldRequired": "Sahə tələb olunur",
      "numbersAndLetters": "Yalnız rəqəmlər və hərflər",
      "email": "Səhv e-poçt",
      "minStringValue": "Sahə ən azı {{min}} hərf olmalıdır",
      "maxStringValue": "Sahə ən çox {{max}} hərflərində olmalıdır",
      "minNumberValue": "Sahə dəyəri ən azı {{min}} olmalıdır",
      "maxNumberValue": "Sahə dəyəri ən çox {{max}} olmalıdır"
    },
    "languages": {
      "spanish": "İspan dili (İspaniya)",
      "english": "İngilis dili (Amerika Birləşmiş Ştatları)"
    },
    "taxpayer-request-types": {
      "enroll": "Qeydlər",
      "update": "Yenilə",
      "unsubscribe": "Abunə Ol"
    },
    "taxpayer-request-states": {
      "pending": "Gözlənilməkdə",
      "pending_additional_information": "Əlavə Məlumat Gözləyən",
      "approved": "Təsdiq edilmiş",
      "rejected": "Rədd Edildi"
    },
    "taxreturn-types": {
      "original": "Orijinal",
      "amending": "Düzəliş"
    },
    "taxreturn-status": {
      "pending": "Gözlənilməkdə",
      "accepted": "Qəbul Edildi",
      "approved": "Təsdiq edilmiş",
      "rejected": "Rədd Edildi",
      "reconciled": "Barışdı"
    },
    "yes-no": {
      "yes": "Bəli",
      "no": "Xeyr"
    }
  },
  "management-report": {
    "label": {
      "taxpayerByCountry": "Ölkələrinə görə",
      "taxpayerByOperation": "Əməliyyatla",
      "taxpayerAmount": "Miqdar",
      "taxAmount": "Vergiyə görə",
      "dateFrom": "Tarix",
      "dateTo": "Tarix"
    },
    "title": {
      "pageTaxpayer": "Vergi ödəyicisi",
      "pageTaxreturn": "Taxreturn",
      "pagePayment": "Ödənişlər"
    },
    "validations": {
      "dateRequired": "Bu tarix tələb olunur",
      "dateToGreaterThan": "Bu tarix Date From-dan böyük olmalıdır",
      "dateLessThreeMonths": "Bu tarix 12 aydan az olmalıdır Date From"
    }
  },
  "non-compliances": {
    "label": {
      "period": "Dövr",
      "expirationDate": "Qurtarmə tarixi",
      "NotificationDate": "Bildiriş tarixi",
      "presentationDate": "Təqdimat tarixi",
      "wait": "Gözlə",
      "penalty": "Cəza",
      "declarationAmount": "Deklarasiya məbləği",
      "paymentAmount": "Ödəniş məbləği",
      "days": "günlər",
      "countTaxpayerNotified": "Bildirişlər",
      "countTaxpayerCompliance": "Təriflər",
      "compliancePercentage": "Tabeçilik",
      "elapsedTime": "Orta vaxt",
      "debtGenerated": "Yaranmış borc"
    },
    "title": {
      "nonCompliancesTax": "Vergiyə görə qeyri-müvafiq",
      "nonCompliances": "Qeyri-uyğunluqlar",
      "nonCompliancesPayments": "Gözlənilən ödənişlər",
      "StatisticQuery": "Konsultulyasiya dövrü",
      "StatisticQueryResult": "Nəticələr"
    }
  },
  "operations-economy-activity": {
    "title": {
      "page": "İqtisadiyyatın fəaliyyəti"
    },
    "label": {
      "code": "Kod",
      "name": "Ad",
      "description": "İzah",
      "newButton": "Yeni",
      "saveButton": "Qeyd Et"
    },
    "header": {
      "code": "Kod",
      "name": "Ad",
      "description": "İzah",
      "actions": "Hərəkət"
    },
    "button": {
      "cancel": "Ləğv etmək",
      "delete": "Sil",
      "save": "Qeyd Et",
      "search": "Axtar",
      "new": "Yeni",
      "clean": "Təmiz",
      "ok": "Yaxşı"
    },
    "validations": {
      "codeRequired": "Kod tələb olunur",
      "nameRequired": "Sahə Adı tələb olunur",
      "descriptionRequired": "Sahə təsviri tələb olunur"
    },
    "messages": {
      "confirmTitle": "Sil",
      "confirmDeleted": "Bu qeydi mütləq silirsiniz?",
      "deletedSucessfully": "Müvəffəqiyyətlə silindi",
      "savedSucessfully": "Müvəffəqiyyətlə qeyd edilib",
      "error": "Xəta"
    }
  },
  "penalties": {
    "label": {
      "periodFrom": "Dövr",
      "periodTo": "Dövr"
    },
    "title": {
      "listPenalties": "Pensiyaların konfiqurasiyası"
    }
  },
  "parameters-catalog": {
    "title": {
      "catalogType": "Kataloq növü",
      "catalog": "Kataloq "
    },
    "label": {
      "type": "Növ",
      "name": "Ad",
      "description": "İzah",
      "field": "Sahə",
      "label": "etiket",
      "parent": "Valideyn",
      "newCatalogType": "Yeni kataloq növü",
      "newCatalog": "Yeni kataloq",
      "code": "Kod",
      "addDefinition": "Tərif əlavə et",
      "newDefinition": "Yeni tə'rif",
      "extaFilds": "İstifadəçi əlavə sahələri",
      "addNameTraslation": "Tərcümə əlavə et"
    },
    "validations": {
      "exists": "Qeyd onsuz da mövcuddur",
      "letterNumberhyphen": "Hərflərin sayı və tireləri icazə verilir"
    },
    "messages": {
      "languageExist": "Dil artıq əlavə edilib"
    }
  },
  "parameters-enviroments": {
    "title": {
      "page-security": "Təhlükəsizlik Mühiti",
      "page-application": "Tətbiq Mühiti"
    },
    "label": {
      "name": "Ad",
      "type": "Növ",
      "value": "Qiymət",
      "newButton": "Yeni",
      "saveButton": "Qeyd Et"
    },
    "validations": {
      "nameRequired": "Sahə Adı tələb olunur",
      "typeRequired": "Sahə Növü tələb olunur",
      "textValueRequired": "Sahə Dəyəri tələb olunur"
    },
    "messages": {
      "savedSucessfully": "Müvəffəqiyyətlə qeyd edilib",
      "error": "Xəta"
    }
  },
  "home-template": {
    "title": {
      "page-home": "Ana səhifə şablonu",
      "page-terms": "Şərtlər və şərtlər şablonu"
    },
    "label": {
      "template": "Şablon"
    },
    "messages": {
      "savedSucessfully": "Müvəffəqiyyətlə qeyd edilib"
    }
  },
  "parameters-notification-template": {
    "title": {
      "page-application": "Tətbiq Bildirişləri",
      "page-security": "Təhlükəsizlik Bildirişləri"
    },
    "label": {
      "template": "Şablon",
      "emailNotification": "E-poçt bildirişi",
      "pushNotification": "Bildirişi itdir",
      "newTemplate": "Yeni şablon",
      "id": "Şablon id",
      "subject": "Subject",
      "inbox": "Gələnlər Qutusu"
    },
    "validations": {
      "templateRequired": "Sahə Şablonu tələb olunur"
    }
  },
  "taxpayer-fields": {
    "title": {
      "page": "Vergi ödəyicilərinin sahələri",
      "enabled": "Fəal"
    },
    "header": {
      "fieldCode": "Kod",
      "fieldName": "Sahə Adı",
      "fieldSection": "Bölmə Adı",
      "actions": "Fəal"
    },
    "messages": {
      "savedSucessfully": "Müvəffəqiyyətlə qeyd edilib"
    }
  },
  "report-details": {
    "stateType": {
      "processing": "İşləmə",
      "error": "Xəta",
      "accepted": "Qəbul Edildi",
      "processed": "İşlənmiş"
    },
    "title": {
      "page": "Hesabat təfsilatları"
    },
    "label": {
      "reportNumber": "Hesabat nömrəsi",
      "reportType": "Hesabat növü",
      "operations": "Əməliyyat növü",
      "taxpayerNumber": "Vergi ödəyicilərinin sayı",
      "taxpayerName": "Vergi ödəyicisi Adı",
      "registrationDate": "Qeydiyyat Tarixi",
      "period": "Dövr",
      "reportName": "Hesabat Adı",
      "record": "Qeyd",
      "index": "indeks",
      "type": "Növ",
      "active": "Fəal",
      "taxReportState": "Ştat"
    }
  },
  "payment-file-status": {
    "processing": "Emal olunur",
    "error": "Xəta",
    "pending": "Gözləmədə",
    "accepted": "Qəbul edildi",
    "rejected": "Rədd edildi",
    "processed": "Emal edildi",
    "received": "Alındı"
  },
  "taxreturn-report": {
    "title": {
      "page": "Taxreturn hesabatları"
    },
    "label": {
      "nit": "TIN",
      "taxreturnNumber": "Taxreturn sayı",
      "country": "Ölkə",
      "formId": "Forma Adı",
      "taxreturnType": "Əməliyyat növü",
      "taxreturnStatus": "Vəziyyət",
      "name": "Vergi ödəyicisinin adı",
      "period": "Dövr",
      "periodFrom": "Dövr",
      "periodTo": "Dövr",
      "active": "Fəal",
      "overview": "Ümumi baxış",
      "taxreturn": "Taxreturn",
      "createDate": "Tarix Yarat",
      "approve": "Təsdiq edilmiş",
      "comments": "Şərh"
    },
    "header": {
      "actions": "Hərəkət",
      "nit": "TIN",
      "name": "Vergi ödəyicisinin adı",
      "taxReturnNumber": "Taxreturn sayı",
      "createDate": "Tarix Yarat",
      "taxreturnType": "Əməliyyat növü",
      "taxreturnStatus": "Vəziyyət",
      "form": "Forma",
      "period": "Dövr",
      "active": "Fəal",
      "rejectionReason": "Rədd edilmənin səbəbi"
    },
    "validations": {},
    "messages": {
      "periodMessage": "İllik dövrlər üçün YYYY formatı, aylıq/dörddə bir dövr YYYYMM"
    },
    "button": {}
  },
  "security-apikey": {
    "title": {
      "page": "Açarlar"
    },
    "label": {
      "name": "Ad",
      "new-api-key": "Yeni Açar",
      "expiration": "İstifadə müddəti",
      "your-pat": "Yeni Şəxsi Giriş Nişanınız",
      "revoke-token": "Nişan"
    },
    "validations": {
      "name": "Api Açar Adı tələb olunur",
      "expiration": "Müddətin bitmə tarixi tələb olunur"
    },
    "message": {
      "key-created": "Əmin olun ki, onu xilas edin - bir də daxil ola bilməyəcəksiniz.",
      "confirm-revoke": "Əminsinizmi ki, nişanı ləğv etmək istəyirsiniz?"
    }
  },
  "audit-log": {
    "title": {
      "event-title": "Hadisə Qeydləri",
      "http-title": "Qeydlər",
      "application": "Tətbiq",
      "security": "Təhlükəsizlik"
    },
    "label": {
      "dateFrom": "Tarix",
      "dateTo": "Tarix",
      "user": "İstifadəçi",
      "aggregateName": "Aqreqat adı",
      "eventName": "Ad:",
      "httpMethod": "Vasitə",
      "httpStatusCode": "Http Status Kodu",
      "id": "İdentifikator",
      "date": "Tarix",
      "url": "URL",
      "ip": "IP",
      "type": "Sorğu növü",
      "consultation": "Baxış",
      "modification": "Dəyişiklik"
    },
    "header": {},
    "validations": {
      "dateRequired": "Bu tarix tələb olunur",
      "dateToGreaterThan": "Bu tarix Date From-dan böyük olmalıdır",
      "dateLessThreeMonths": "Bu tarix Date From 3 aydan az olmalıdır"
    },
    "messages": {}
  },
  "disable-tfa": {
    "label": {
      "title": "İki faktorlu autentifikasiyanı qeyri-fəallaşdır (2FA)",
      "disable": "2FA-nı qeyri-fəallaşdır"
    },
    "validations": {},
    "message": {
      "alert-1": "Bu hərəkət yalnız 2FA-nı qeyri-fəal edir.",
      "alert-2": "2FA-nın qeyri-fəallaşdırılması authenticator proqramlarında istifadə olunan açarları dəyişmir. ",
      "alert-3": "Əgər authenticator proqramında istifadə olunan açarı dəyişmək istəyirsinizsə, mütləq:",
      "alert-4": "tanıtıcı açarlarınızı sıfırlayın.",
      "success": "2fa əlil olub. Authenticator proqramı qurduqda 2fa-nı yenidən bərpa edə bilərsiniz"
    }
  },
  "enable-authenticator": {
    "label": {
      "title": "Tanıtıcı proqramını quraşdır",
      "verification-code": "Yoxlama Kodu",
      "verification-code-digit": "{{position}} / {{total}} rəqəm",
      "verify": "Təsdiqlə",
      "manual-key": "Əl ilə quraşdırma açarı",
      "copy-key": "Açarı kopyala",
      "key-copied": "Açar buferə kopyalandı.",
      "key-copied-button": "Kopyalandı",
      "copy-unavailable": "Açarı kopyalamaq mümkün olmadı. Onu əl ilə kopyalayın.",
      "security-recommendations": "Təhlükəsizlik tövsiyələri",
      "security-recommendations-detail": "Bərpa kodlarını təhlükəsiz yerdə saxlayın və quraşdırma açarını paylaşmayın."
    },
    "validations": {
      "code": "Yoxlama Kodu tələb olunur"
    },
    "message": {
      "instruction-1": "Microsoft Authenticator kimi iki fakturalı authenticator proqramını yükləyin",
      "and": "və",
      "or": "və ya",
      "for": "üçün",
      "instruction-2": "QR Kodu skan edin və ya bu açarı daxil edin",
      "instruction-3": "iki fakturalı authenticator proqramınıza daxil olun. Boşluq və kasanın əhəmiyyəti yoxdur.",
      "instruction-4": " Qr kodu skan etdikdən və ya yuxarıda açarı daxil etdikdən sonra, iki faktor təsdiqləmə proqramınız sizə unikal kod təqdim edəcək. Kodu aşağıdakı təsdiq qutusuna daxil edin."
    }
  },
  "recovery-codes": {
    "label": {
      "title": "Bərpa kodları",
      "available-once": "İndi yadda saxlayın: onlar yenidən tam şəkildə göstərilməyəcək."
    },
    "message": {
      "save-security-codes": "Bu kodları təhlükəsiz yerə qoyun.",
      "if-you-lose": "Cihazınızı itirsəniz və bərpa kodlarına sahib olmasanız hesabınıza girişi itirəcəksiniz."
    }
  },
  "generate-recovery-codes": {
    "label": {
      "title": "İki faktorlu autentifikasiya (2FA) bərpa kodlarını generasiya edin",
      "generate": "Recovery Codes-ləri generasiya edin"
    },
    "validations": {},
    "message": {
      "alert-1": "Bu kodları təhlükəsiz yerə qoyun.",
      "alert-2": " Cihazınızı itirsəniz və bərpa kodlarına sahib olmasanız hesabınıza girişi itirəcəksiniz.",
      "alert-3": "Yeni bərpa kodlarının əmələ gəlməsi authenticator proqramlarında istifadə olunan açarları dəyişmir. Authenticator proqramında istifadə olunan açarı dəyişmək istəyirsinizsə, etməlisiniz",
      "alert-4": "tanıtıcı açarlarınızı sıfırlayın."
    }
  },
  "security-login": {
    "title": {
      "login": "Giriş"
    },
    "label": {
      "username": "İstifadəçi Adı",
      "password": "Şifrə",
      "rememberMe": "Xatırla məni",
      "loginButton": "Giriş",
      "passwordRecovery": "Şifrəni geri qaytar",
      "notRegistered": "Hələ qeydiyyatdan keçməyib ?",
      "signup": "İndi imza at",
      "loginAlternative": "və ya",
      "forgotPassword": "Şifrəni unutdun?",
      "next": "Sonrakı",
      "forgotPasswordInstructions": "İstifadəçi adınızı daxil edin və biz sizə onu geri almaq üçün ətraflı təlimatlarla məktub göndərəcəyik",
      "externalLogin": "Xarici Giriş",
      "captcha-placeholder": "Captcha daxil ol"
    },
    "validations": {
      "usernameRequired": "Sahə İstifadəçi adı tələb olunur",
      "passwordRequired": "Sahə Şifrəsi tələb olunur",
      "captchaValidationRequired": "Captcha doğruluğu tələb olunur"
    }
  },
  "login-with-2fa": {
    "title": {
      "login": "İki faktorlu autentifikasiya",
      "login-recovery": "Recovery kodun yoxlanılması"
    },
    "label": {
      "twoFactorCode": "Təsdiqləyici kodu",
      "recoveryCode": "Bərpa kodu",
      "rememberBrowser": "Bu səyyahı yadda saxla",
      "verificationCodeInstructions": "Davam etmək üçün autentifikator tətbiqinizdəki altı rəqəmli kodu daxil edin.",
      "loginButton": "Giriş",
      "loginRecovery": "Recovery kodu ilə giriş"
    },
    "message": {
      "no-access": " Autentifikasiya cihazınıza giriş yoxdur? Sən bacararsan",
      "trustedBrowser": "Bu etibarlı brauzerdə doğrulamanı keçin.",
      "recovery-requested": " Siz bərpa kodu ilə daxil olmaq üçün xahiş etdik. 2FA-da log in və ya disable-də authenticator proqram kodu təqdim etməyincə və yenidən daxil olmayınca bu giriş yadda olmayacaq."
    },
    "validations": {
      "twoFactorCode": "Sahə Autentifikasiya kodu tələb olunur",
      "recoveryCode": "Sahə Recovery kodu tələb olunur"
    }
  },
  "security-password-recovery": {
    "label": {
      "title": "Şifrəni Geri Qaytar",
      "changePassword": "Şifrəni dəyiş",
      "userName": "İstifadəçi Adı",
      "newPassword": "Şifrə",
      "repeatPassword": "Şifrəni təkrarla",
      "returnLogin": "Girişə qayıt"
    },
    "message": {
      "email-sended": "Şifrə e-poçtunu geri qaytar",
      "password-changed": "Şifrə uğurla dəyişdirildi"
    },
    "validations": {
      "newPassword": "Yeni şifrə ən azı 6 hərf olmalıdır",
      "passwordEqual": "Şifrə uyğun gəlmir"
    }
  },
  "reset-authenticator": {
    "label": {
      "title": "Qurğu autentifikasiya proqramı",
      "reset": "Tanıtıcı açarı sıfırla",
      "configure": "Tanıtıcı proqramını quraşdır"
    },
    "validations": {},
    "message": {
      "alert-1": "Authenticator açarınızı sıfırlasanız, authenticator proqramınızı yenidən quraşdırmayıncə işləməyəcəksiniz.",
      "alert-2": "Bu proses 2FA-nı authenticator proqramınızı yoxlayana qədər qeyri-fəal edir.",
      "alert-3": "Authenticator proqram konfiqurasiyasını tamamlamasanız hesabınıza girişinizi itirə bilərsiniz.",
      "success": "Authenticator app açarınız sıfırlanıb, yeni açardan istifadə edərək authenticator proqramınızı konfiqurasiya etmək lazım gələcək."
    }
  },
  "tfa": {
    "title": {
      "page": "İki Faktor autentifikasiyası"
    },
    "label": {
      "title": "İki faktorlu autentifikasiya (2FA)",
      "authenticator-app": "Tanıtma proqramı",
      "setup-authenticator": "Qurğu autentifikasiya proqramı",
      "add-authenticator": "Tanıtma proqramını əlavə et",
      "reset-authenticator": "Tanıtıcı proqramını sıfırla",
      "reset-recovery-codes": "Bərpa kodlarını sıfırla",
      "disable-2fa": "2FA-nı qeyri-fəallaşdır",
      "forget-this-browser": "Bu brauzeri unut",
      "status-enabled": "Aktiv",
      "status-disabled": "Konfiqurasiya edilməyib",
      "recovery-codes-remaining": "bərpa kodu mövcuddur",
      "danger-zone": "Yüksək təsirli əməliyyatlar"
    },
    "validations": {},
    "message": {
      "two-factor-forgotten": "Hazırkı brauzer unudulub. Bu brauzerdən yenidən daxil olduqda 2fa kodunuz sizə təlqin olunacaq.",
      "no-codes-left-1": "Sizin bərpa kodlarınız qalmayıb.",
      "no-codes-left-2": "Məcbursan",
      "no-codes-left-3": "yeni bərpa kodları dəsti yaradır",
      "no-codes-left-4": "bərpa kodu ilə daxil olmazdan əvvəl.",
      "some-codes-left-1": "Sənin var",
      "some-codes-left-2": "bərpa kodları qaldı.",
      "some-codes-left-3": "Gərək ",
      "some-codes-left-4": "yeni bərpa kodları dəsti yaradır"
    }
  },
  "roles": {
    "account_reports": "Hesab hesabatları",
    "catalogs_admin": "Kataloq administratoru",
    "details_reports": "Ətraflı Hesabatlar",
    "environments_admin": "Ətraf Mühit İdarəçisi",
    "forms_admin": "Form İdarəçisi",
    "management_report_admin": "İdarəetmə Hesabatları Administratoru",
    "notifications_admin": "Bildirişlər İdarəçisi",
    "system_auditor": "Sistem Auditoru",
    "taxpayer_reports": "Vergi ödəyicisinin hesabatları",
    "taxpayers_admin": "Vergi ödəyiciləri İdarəçisi",
    "payments_admin": "Ödəniş meneceri",
    "taxpayers_approver": "Vergi ödəyicilərinin təsdiq edən",
    "taxreturn_approver": "Taxreturn Təsdiq edən",
    "taxreturn_reports": "Taxreturn hesabatları",
    "tfa_admin": "2FA Administrator",
    "users_admin": "İstifadəçi administratoru",
    "current_account_admin": "Hazırkı Hesab İdarəsi",
    "debt_collection_analyst": "Borc yığımı analitiki",
    "debt_collection_manager": "Borcun yığılması üzrə menecer",
    "debt_collection_officer": "Borcun yığılması üzrə zabit",
    "taxpayer_communication": "Vergi ödəyicisi ilə ünsiyyət",
    "non_compliance_analyst": "Qeyri-uyğunluq analitiki",
    "collection_statistics": "Toplama analizi",
    "compliance_statistics": "Qeyri-uyğunluq analizi"
  },
  "taxreturn-evaluation": {
    "title": {
      "page": "Düzəlişlərin yenidən baxılması",
      "approve": "Düzəlişi təsdiqlə",
      "reject": "Düzəlişi rədd et",
      "dialog-confirm": "Təsdiqlə"
    },
    "label": {
      "nit": "TIN",
      "taxreturnNumber": "Taxreturn sayı",
      "country": "Ölkə",
      "taxId": "Vergi",
      "taxreturnType": "Əməliyyat növü",
      "name": "Vergi ödəyicisinin adı",
      "form": "Forma",
      "approve": "Təsdiqlə",
      "taxpayer": "Vergi ödəyicisi",
      "comments": "Şərh",
      "general-comments": "Ümumi Şərhlər",
      "periodFrom": "Dövr",
      "periodTo": "Dövr"
    },
    "header": {
      "actions": "Hərəkət",
      "nit": "TIN",
      "name": "Vergi ödəyicisinin adı",
      "taxReturnNumber": "Taxreturn sayı",
      "form": "Forma",
      "tax": "Vergi",
      "taxreturnStatus": "Vəziyyət",
      "period": "Dövr",
      "createDate": "Tarix Yarat"
    },
    "validations": {},
    "messages": {
      "approved": "Taxreturn təsdiq edilib",
      "rejected": "\"Taxreturn\"dan imtina edildi",
      "confirm": "Əminsinizmi ki, bu hərəkəti etmək istəyirsiniz?"
    },
    "button": {
      "reject": "Rədd Et",
      "approve": "Təsdiqlə"
    }
  },
  "taxes": {
    "title": {
      "page": "Vergiləri İdarə Et"
    },
    "label": {
      "name": "Ad",
      "rateType": "Qiymət növü",
      "shortName": "Qısa Ad",
      "code": "Kod",
      "newButton": "Yeni",
      "saveButton": "Qeyd Et",
      "tabEditTax": "Ümumi",
      "tabRates": "Qiymətlər",
      "rate": "Qiymət",
      "tabPeriodicity": "Dövrilik",
      "tabOperations": "Əməliyyatlar",
      "dateFrom": "Tarix",
      "dateTo": "Tarix",
      "value": "Qiymət",
      "periodicityType": "Dövrilik növü",
      "filingDueDay": "Müddətin bitmə günü",
      "paymentDueDay": "Ödəmə günü"
    },
    "header": {
      "code": "Kod",
      "name": "Ad",
      "rateType": "Qiymət növü",
      "value": "Qiymət",
      "dateFrom": "Tarix",
      "dateTo": "Tarix",
      "shortName": "Qısa Ad",
      "actions": "Hərəkət",
      "periodicityType": "Dövrilik növü",
      "filingDueDay": "Müddətin bitmə günü"
    },
    "validations": {
      "rateTypeRequired": "Sahə Qiymət Növü tələb olunur",
      "shortNameRequired": "Sahə Qısa adı tələb olunur",
      "codeRequired": "Sahə Kodu tələb olunur",
      "valueLessThan100": "Sahə Dəyəri 100% -dən az olmalıdır",
      "valueRequired": "Sahə Dəyəri tələb olunur",
      "dateFromRequired": "\"Tarixdən\" sahəsi tələb olunur",
      "dateToRequired": "\"Date To\" sahəsi tələb olunur",
      "filingDueDayRequired": "Sahənin müddəti başa çatması günü tələb olunur",
      "periodicityTypeRequired": "Sahə Periodiklik Növü tələb olunur"
    },
    "messages": {
      "savedSuccessfully": "Müvəffəqiyyətlə qeyd edilib",
      "deletedSuccessfully": "Müvəffəqiyyətlə silindi",
      "error": "Xəta"
    }
  },
  "reportOperation": {
    "title": {
      "page": "Hesabat Əməliyyatlarını İdarə Et",
      "warning": "Xəbərdarlıq"
    },
    "label": {
      "operation": "Əməliyyat",
      "report": "Hesabat"
    },
    "header": {
      "operation": "Əməliyyat",
      "report": "Hesabat",
      "actions": "Hərəkət"
    },
    "messages": {
      "removeReportOperation": "Onu mütləq silərsiniz?"
    }
  },
  "reports": {
    "title": {
      "page": "Hesabatları İdarə Et",
      "report": "Hesabat",
      "versions": "Tərcümələr"
    },
    "label": {
      "name": "Ad",
      "shortName": "Qısa Ad",
      "code": "Kod",
      "newButton": "Yeni",
      "saveButton": "Qeyd Et",
      "tabEditReport": "Ümumi",
      "tabPeriodicity": "Dövrilik",
      "dateFrom": "Tarix",
      "dateTo": "Tarix",
      "periodicityType": "Dövrilik növü",
      "filingDueDay": "Müddətin bitmə günü"
    },
    "header": {
      "code": "Kod",
      "name": "Ad",
      "shortName": "Qısa Ad",
      "actions": "Hərəkət",
      "dateFrom": "Tarix",
      "dateTo": "Tarix",
      "periodicityType": "Dövrilik növü",
      "filingDueDay": "Müddətin bitmə günü"
    },
    "validations": {
      "shortNameRequired": "Sahə Qısa adı tələb olunur",
      "codeRequired": "Sahə Kodu tələb olunur",
      "dateFromRequired": "\"Tarixdən\" sahəsi tələb olunur",
      "dateToRequired": "\"Date To\" sahəsi tələb olunur",
      "filingDueDayRequired": "Sahənin müddəti başa çatması günü tələb olunur",
      "periodicityTypeRequired": "Sahə Periodiklik Növü tələb olunur"
    },
    "messages": {
      "savedSuccessfully": "Müvəffəqiyyətlə qeyd edilib",
      "deletedSuccessfully": "Müvəffəqiyyətlə silindi",
      "error": "Xəta"
    }
  },
  "report-cells": {
    "title": {
      "page": "Hüceyrələr"
    },
    "label": {
      "code": "Hüceyrə kodu",
      "name": "Hüceyrə adı",
      "description": "İzah",
      "formula": "Formula",
      "order": "Sifariş",
      "type": "Növ",
      "numeric": "Numizmatika",
      "currency": "Pul vahidi",
      "date": "Tarix",
      "list": "Siyahı",
      "text": "Mətn",
      "catalogType": "Kataloq növü",
      "mandatory": "Mütləq"
    },
    "messages": {
      "confirmTitle": "Sil",
      "confirmDeleted": "Əminsinizmi ki, silmək istəyirsiniz?"
    }
  },
  "report-version": {
    "title": {
      "page": "Hesabat versiyası"
    },
    "label": {
      "version": "Versiyon",
      "formVersion": "Form versiyası",
      "startDate": "Başlama tarixi",
      "endDate": "Bitiş tarixi",
      "formCode": "Forma kodu",
      "formName": "Forma adı",
      "since": "Bəri",
      "tabVersion": "Versiyon",
      "fields": "Elanlar"
    },
    "messages": {
      "confirmTitle": "Sil",
      "confirmDeleted": "Siz mütləq silinirsiniz?"
    }
  },
  "taxOperation": {
    "title": {
      "page": "Vergi əməliyyatlarının idarəolun",
      "warning": "Xəbərdarlıq"
    },
    "label": {
      "operation": "Əməliyyat",
      "tax": "Vergi"
    },
    "header": {
      "operation": "Əməliyyat",
      "tax": "Vergi",
      "actions": "Hərəkət"
    },
    "messages": {
      "removeTaxOperation": "Onu mütləq silərsiniz?",
      "allOperationsLinked": "Bütün əməliyyatlar artıq bu vergi ilə əlaqələndirilib",
      "noLinkedOperations": "Bu vergi ilə əlaqələndirilmiş əməliyyat yoxdur"
    }
  },
  "form-administration": {
    "title": {
      "page": "Vergi Bəyannaməsi Forması İdarəsi ",
      "form": "Forma",
      "versions": "Tərcümələr"
    },
    "label": {
      "code": "Kod",
      "name": "Ad",
      "shortName": "Qısa ad",
      "tax": "Vergi",
      "numberModifications": "Nömrə Dəyişmləri",
      "amendmentApprovalRequired": "Düzəlişin təsdiq edilməsi tələb olunur",
      "form": "Formalar",
      "versions": "Tərcümələr"
    },
    "header": {
      "actions": "Hərəkət",
      "code": "Kod",
      "name": "Ad",
      "shortName": "Qısa ad",
      "tax": "Vergi"
    },
    "messages": {
      "confirmTitle": "Sil",
      "confirmDeleted": "Siz mütləq silinirsiniz?"
    }
  },
  "form-cells": {
    "title": {
      "page": "Hüceyrələr",
      "serviceParameters": "Xidmət Parametrləri",
      "serviceHeaders": "Xidmət Başlığı"
    },
    "label": {
      "noFoundCells": "Formanın müəyyən edilmiş hüceyrələri yoxdur",
      "code": "Hüceyrə kodu",
      "name": "Hüceyrə adı",
      "description": "İzah",
      "section": "Bölmə",
      "formula": "Formula",
      "order": "Sifariş",
      "type": "Növ",
      "service": "Xidmət",
      "mandatory": "Mütləq",
      "editable": "Düzəldilə bilən",
      "visible": "Görünən",
      "cellPurpose": "Xana məqsədi",
      "numeric": "Numizmatika",
      "currency": "Pul vahidi",
      "date": "Tarix",
      "list": "Siyahı",
      "text": "Mətn",
      "catalogType": "Kataloq növü",
      "parameterName": "Ad",
      "addParameter": "Parametrləri Əlavə Et",
      "headerName": "Ad",
      "addHeader": "Başlıq Əlavə Et"
    },
    "messages": {
      "confirmTitle": "Sil",
      "confirmDeleted": "Siz mütləq silinirsiniz?"
    }
  },
  "form-section": {
    "labels": {
      "description": "İzah",
      "order": "Sifariş",
      "code": "Kod",
      "sectionType": "Bölmə növü",
      "isMultiple": "Çoxsaylı bölmə",
      "minInstances": "Minimum instanslar",
      "maxInstances": "Maksimum instanslar"
    },
    "provisioning": {
      "simple": "Sadə",
      "multiple": "Çoxsaylı",
      "jurisdiction": "Yurisdiksiya"
    }
  },
  "form-version": {
    "title": {
      "page": "Vergi Bəyannaməsi Forması versiyası",
      "current-account-rules": "Cari Hesab Qaydaları"
    },
    "labels": {
      "noFoundVersion": "Heç bir versiya mövcud deyil",
      "version": "Versiyon",
      "formVersion": "Form versiyası",
      "startDate": "Başlama tarixi",
      "endDate": "Bitiş tarixi",
      "formCode": "Forma kodu",
      "formName": "Forma adı",
      "since": "Bəri",
      "generalData": "Ümumi məlumat",
      "fields": "Hüceyrələr",
      "sections": "Bölmələr",
      "enabled": "Fəal",
      "preview": "Önbaxış",
      "current-account-rules": "Cari Hesab Qaydaları",
      "account-type-header": "Hesab növü",
      "transaction-type-header": "Transaksiya növü",
      "cell-header": "Hüceyrə",
      "account-type": "Hesab növü",
      "transaction-type": "Transaksiya növü",
      "cell": "Hüceyrə"
    }
  },
  "preview-form": {
    "label": {
      "preview": "Önbaxış",
      "year": "Dövr",
      "taxpayer": "Vergi ödəyicisinin id",
      "nit": "TIN",
      "taxpayerName": "Vergi ödəyicisinin adı",
      "validTestTaxpayer": "Sınaq imtahanı vermək üçün vergi ödəyicisinə əsaslı tapılmadı",
      "validTestTax": "Vergi ödəyicisinin bu forma ilə bağlı vergisi yoxdur",
      "formulaLog": "Formula qeydi"
    },
    "messages": {
      "formVersionNotFound": "Form versiyası tapılmadı",
      "taxReturnExist": "Artıq bu dövr üçün taksreturn mövcuddur"
    }
  },
  "taxpayer-current-account": {
    "title": {
      "currentAccount": "Hazırkı Hesab",
      "amendingCredit": "Balans sorğusu",
      "currentAccountTransaction": "Əməliyyat detalları",
      "transactionAdjustment": "Tərəzi düzəlişi"
    },
    "label": {
      "nit": "TIN",
      "tax": "Vergi",
      "taxCode": "Vergi kodu",
      "period": "Dövr",
      "taxAmount": "Vergi məbləği",
      "penalty": "Cəza",
      "interest": "Maraqlar",
      "taxArrears": "Vergiyə görə vergilər",
      "total": "ümumi",
      "expirationDate": "Qurtarmə tarixi",
      "accountType": "Hesab növü",
      "balance": "Tarazlı",
      "date": "Tarix",
      "transactionType": "Transaksiya növü",
      "value": "Qiymət",
      "document": "Sənəd",
      "taxpayerName": "Ad",
      "credit": "Kredit",
      "debit": "Debet"
    },
    "dialog": {},
    "messages": {},
    "validations": {
      "nit-required": "Nit tələb olunur"
    }
  },
  "taxpayer-payments": {
    "title": {
      "page": "Ödəniş sorğusu",
      "paymentsByJurisdiction": "Yurisdiksiya üzrə ödənişlər",
      "pagePayments": "Ödəniş rekordu",
      "pageUploadPayments": "Ödəniş yükü",
      "selectTaxReturn": "VergiNin qaytarılmasını seçin",
      "reconciliationPayments": "Ödənişlərin razılaşdırması",
      "paymentsTaxpayer": "Vergi ödəyicisinin verdiyi ödənişlər barədə məlumat verilib.",
      "paymentsTaxCollect": "Toplanan orqanın verdiyi ödənişlər.",
      "concialiation": "Barış.",
      "checkBankInformation": "Bank məlumatlarının yoxlanılması"
    },
    "label": {
      "registerPayment": "Ödəniş rekordu",
      "amountTaxReturn": "Deklarasiya məbləği",
      "totalDebt": "Total debt",
      "amountTaxpayer": "Vergi ödəyicisinin məbləği.",
      "amountBank": "Bank məbləği",
      "amountFrom": "Alınan məbləğ",
      "amountTo": "Qədər məbləğ",
      "tax-id": "Verginin müəyyənləşdirilməsi",
      "name": "Ad",
      "date-from": "Tarix",
      "date-to": "Tarix:",
      "date-payment": "Ödəmə tarixi",
      "payment-number": "Ödəniş nömrəsi",
      "exchange-rate": "Valyuta məzənnəsi.",
      "local-amount": "Yerli valyutada məbləğ",
      "tax": "Vergi",
      "amount": "Miqdar",
      "excelDefinition": "Excel fayl təsnifatı",
      "taxCollector": "Vergiyığan",
      "swiftNumber": "Swift təsdiq nömrəsi",
      "uploadNumber": "Nömrəni yüklə",
      "hasErrors": "Xətaları var",
      "date-payment-bank": "Alınan tarix"
    },
    "messages": {
      "paymentRegisteredSucessfully": "[createDate] saytında ödəniş uğurla qeydiyyata alındı",
      "diferentCurrencyCode": "Müxtəlif valyutaların ödənişləri ilə barışa bilməzsiniz",
      "exceedsTolerance": "İcazə verilən [tolerence]% tolerantlığını aşır",
      "paymentGreaterThen": "Vergi ödəyicisinin hesabat verdiyi ödənişlər vergi ödəyicisinin hesabat verdiyi ödənişdən yüksəkdir"
    }
  },
  "taxpayer-report": {
    "title": {
      "page": "Vergi ödəyicisinin hesabatı"
    },
    "label": {
      "name": "Ad",
      "nit": "TIN",
      "county": "Ölkə",
      "personType": "Şəxs növü",
      "email": "E-poçt"
    }
  },
  "taxpayer-request": {
    "label": {
      "personType": "Kəs",
      "businessName": "İş adı",
      "fullName": "Tam adı",
      "id": "İdentifikasiya nömrəsi",
      "taxNumber": "Vergi nömrəsi",
      "phoneNumber": "Telefon nömrəsi",
      "domicile": "Domicile",
      "department": "Şöbə/Provice/Dövlət",
      "addContact": "Əlaqə əlavə et",
      "operations": "Gedişlər",
      "contacts": "Üzvlər",
      "taxVector": "Vergi vekselin",
      "reportVector": "Hesabat",
      "generalData": "Ümumi",
      "tax": "Vergi",
      "taxObligation": "Vergi",
      "report": "Hesabat",
      "website": "Veb-sayt",
      "idTax": "İdentifikasiya vergi nömrəsi",
      "contactName-tax": "Yaşayış yeri üzrə ölkə ərazisində əlaqə adı",
      "docNumberContact-tax": "Yaşayış yeri üzrə ölkə üzrə əlaqənin sənəd nömrəsi",
      "contactTaxIdNumber-tax": "Əlaqə vergisinin identifikasiya nömrəsi",
      "phoneNumberContact-tax": "Yaşayış yeri üzrə ölkə ərazisində əlaqənin telefon nömrəsi",
      "email-tax": "E-Mail ilə əlaqə saxlayın",
      "documents": "Sənədlər",
      "docCompanyRegistrationNumber": "Şirkətin qeydiyyat sənədi",
      "docLocalContact": "Yerli əlaqə qeydiyyatlı şəxsiyyət",
      "acceptance": "Qəbul",
      "taxpayerRequest": "POSS Qeydiyyatı",
      "confirmTerms": "Şərt və şərtləri qəbul etmək",
      "terms": "Lorem ipsum dolor sit amet consectetur adipiscing elit per, penatibus euismod ac libero praesent sollicitudin lacinia nulla platea, nam hac cursus cubilia congue luctus dapibus. Iaculis luctus egestas accumsan eleifend metus dis aptent quisque, lacus vitae nullam habitasse ad mollis tempor, mattis ornare dapibus laoreet auctor tellus dui. Ante integer sagit erat accumsan vulputate potenti senectus, rutrum ullamcorper nam hendrerit ridiculus faucibus, parturient fames ligula venenatis tristique inceptos.\n\nCum aliquet tempor cras non potenti inceptos aptent, mauris scelerisque mollis auctor libero porta id ut, sodales vulputate eget imperdiet netus posuere. Iaculis dignissim himenaeos magna luctus nulla egestas porttitor, eros vulputate volutpat sociosqu quisque mollis donec, class placerat justo vivamus imperdiet accumsan. Ultrices facilisi phasellus augue cursus etiam viverra suspendisse est, nam vulputate tempor posuere dignissim feugiat sed hac sodales, diam tristique pretium auctor ad erat sem. Et enim gravida magnis malesuada nam nascetur fermentum, proin platea elementum nec penatibus ultricies, blandit cubilia aptent neque praesent sociis.\n\nSagittis augue enim nam sociis, ornare est mi himenaeos, risus proin sodales. Proin malesuada integer aliquam cubilia neque natoque velit, feugiat elementum quis quisque suscipit fermentum conubia, nisi a ligula duis sapien tellus. Praesent mattis fringilla habitant nulla sollicitudin bibendum habitasse at cum quis mus iaculis mi magna sodales, velit hendrerit inceptos dictum neque montes turpis tellus nam morbi commodo nullam senectus.\n\nArcu primis eu conubia fusce nisi vehicula posuere leo sollicitudin eleifend, phasellus sodales congue ligula consequat volutpat magnis facilisi curabitur maecenas, et dis velit libero hac proin habitant sociis nascetur. Nunc tortor penatibus mi ultrices risus nec elementum justo, mattis ad ac tempus vel habitasse accumsan sed parturient, lectus lacinia conubia malesuada volutpat egestas nulla. Himenaeos consequat vitae class mattis taciti nec habitant eleifend, elementum netus eget parturient suspendisse porttitor in felis maecenas, curabitur morbi odio gravida vivamus per bibendum.\n\nTortor non sociosqu accumsan orci vel ligula risus nisl, penatibus odio magnis ullamcorper pellentesque habitant lacinia consequat, aptent nec congue nisi egestas sociis quam. Turpis sociis eu est parturient in fames aliquet nisl, dui natoque phasellus aliquam posuere curae aptent porta, tortor condimentum molestie netus cubilia inceptos lacinia. Auctor laoreet purus nostra dapibus sollicitudin tincidunt dictum nisl lacinia erat, est rhoncus fusce phasellus blandit etiam inceptos suspendisse magna, duis pellentesque nam hac neque musnissim a enim.\n\nNeque proin felis laoreet senectus nullam netus sollicitudin odio tincidunt, penatibus parturient facilisis porta duis sagittis malesuada varius sociosqu congue, aptent velit pellentesque mauris egestas nibh semper orci. Torquent nec commodo erat eu pharetra natoque, senectus velit nascetur curae sollicitudin mus phasellus. Aenean diam ut nibh vulputat neque fusce penatibus class porta mattis imperdiet risus ante, ac lectus habitasse posuere facilisis luctus varius mus tempus non mollis.\n\nDictumst eleifend vehicula purus hendrerit volutpat primis integer, per senectus fusce nulla cubilia dictum feugiat auctor, ultricies sociosqu nisl mi class magnis. Ligula himenaeos phasellus pulvinar accumsan platea egestas sodales hendrerit sagittis augue, curae nec molestie pretium cum parturient lacus euismod sociosqu ullamcorper duis, dignissim fusce libero maecenas congue lobortis penatibus nisi justo.\n\nCum rutrum vehicula convallis pellentesque maecenas nascetur proin congue platea, posuere neque facilisi ullamcorper nibh curae sodales non, cursus nisl cras morbi interdum vitae auctor cubilia. Ligula taciti enim donec congue bibendum fusce eros rhoncus suscipit, dui parturient potenti odio sapien non erat eget, tincidunt convallis primis quam tortor consequat sodales per. Neque hendrerit erat nunc hac ullamcorper molestie fermentum, tristique ultrices sociis vivamus volutpat lectus, vestibulum vehicula aenean mattis magna posuere. Justo condimentum tempor taciti laoreet inceptos per hendrerit eleifend consequat lacus nostra enim, convallis praesent dui faucibus lobortis quam pharetra odio mauris duis.\n\nMagna ultrices dui netus laoreet odio rhoncus maecenas nec placerat rutrum, massa duis nam nulla velit quis fringilla habitasse. Eu integer diam lectus ullamcorper torquent ante aliquet cras feugiat inceptos placerat ut, porta libero nam mauris volutpat habitasse iaculis lacinia facilisi hendrerit nostra.\n\nLaoreet risus nisi sociosqu inceptos maecenas blandit phasellus bibendum, nostra velit fringilla tristique mus donec lectus semper, est tortor nascetur curae scelerisque himenaeos sagittis. Quam volutpat eros non nec nascetur justo, velit tristique nisl arcu est, ultricies sapien convallis metus vulputate. Kondimentum justo ad varius habitant nunc gravida sed vivamus, maecenas ut congue aenean ligula proin lectus, natoque urna duis dui semper egestas habitasse.\n\nAnte et luctus porta malesuada accumsan cursus senectus dictumst penatibus pretium nullam, id condimentum proin felis aliquam sollicitudin varius velit lobortis class placerat, praesent ridiculus eget nisl metus tristique maecenas semper himenaeos parturient. Enim laoreet vulputat orci dui lectus purus bibendum vivamus posuere est curabitur, cubilia fames nulla porta in scelerisque cursus nunc a ligula pretium dictum, mi molestie pulvinar torquent litora vitae fusce eget curae sem. Dapibus quam facilisi cras pharetra mus curabitur, parturient a malesuada integer vitae etiam suspendisse, fermentum massa libero curae neque.",
      "locale": "Üstünlük verilmiş dil",
      "queryOfRequest": "Sorğu",

      "acquirerId": "Məsabiqə İD",
      "acquirerCountry": "Məsabiqənin ölkəsi",
      "terminalId": "Terminal İD",
      "merchantCategoryCode": "Təcəssümçü kateqoriya kodu",
      "merchantId": "Təcəssümçü İD",
      "documentNumberCountryResidence": "Yaşadığı ölkənin sənəd nömrəsi"
    },
    "vector": {
      "label": {
        "tax": "Vergi",
        "expiration": "Müddətin bitmə günü",
        "periodicity": "Dövrilik",
        "startOperation": "Əməliyyat Başla"
      }
    },
    "dialog": {},
    "messages": {
      "contacts": "Ən azı bir əlaqə tələb olunur",
      "operations": "Ən azı bir əməliyyat tələb olunur",
      "selectOperations": "Əlaqəli əməliyyatlar",
      "withoutOperations": "Heç bir əməliyyat yoxdur",
      "withoutOperationsVector": "Onun əlaqəli vergiləri yoxdur",
      "withoutOperationsReport": "Onun əlaqəli hesabatları yoxdur",
      "withoutDocuments": "Heç bir fayl tərifi yoxdur"
    },
    "validations": {
      "acceptance": "Sahə yoxlanmalıdır",
      "formComplete": "Bütün formanı tamamla"
    }
  },
  "taxpayer-request-val": {
    "title": {
      "page": "Vergi ödəyicilərinin müraciətləri",
      "approve": "Xahişləri qəbul etmək",
      "reject": "rədd cavabı",
      "request-additional-info": "Əlavə məlumat istə",
      "request": "İstinad"
    },
    "label": {
      "check-digit": "Yoxla",
      "date-from": "Tarix",
      "date-to": "Tarix",
      "request-type": "İstinad növü",
      "request": "İstinad",
      "type": "Növ",
      "taxpayer": "Vergi ödəyicisi",
      "state": "Ştat",
      "approve": "Təsdiqlə",
      "reject": "Rədd Et",
      "request-additional-info": "Qayıt",
      "comments": "Şərh",
      "reason": "Səbəb",
      "createdDate": "Tarix",
      "cancellationDate": "İmtina tarixi"
    },
    "message": {
      "approved": "Xahiş qəbul edilib",
      "rejected": "Xahiş Rədd Edildi",
      "request-additional-info": "Əlavə məlumat istənildi",
      "periodictyOutOfDate": "Vergi və ya hesabat dövriliyi köhnəlmişdir"
    }
  },
  "taxpayer-taxreturns": {
    "title": {
      "page": "Taxreturn hesabatları"
    },
    "label": {
      "nit": "TIN",
      "taxreturnNumber": "Taxreturn sayı",
      "country": "Ölkə",
      "formId": "Forma",
      "taxreturnType": "Əməliyyat növü",
      "taxreturnStatus": "Vəziyyət",
      "name": "Vergi ödəyicisinin adı",
      "period": "Dövr",
      "periodFrom": "Dövr",
      "periodTo": "Dövr",
      "active": "Fəal"
    },
    "header": {
      "actions": "Hərəkət",
      "nit": "TIN",
      "name": "Vergi ödəyicisinin adı",
      "taxReturnNumber": "Taxreturn sayı",
      "createDate": "Tarix Yarat",
      "taxreturnType": "Əməliyyat növü",
      "taxreturnStatus": "Vəziyyət",
      "form": "Forma",
      "period": "Dövr",
      "active": "Fəal"
    },
    "validations": {},
    "messages": {},
    "button": {}
  },
  "taxpayer-update-request": {
    "title": {
      "page": "Yenilənmə qeydiyyatı"
    }
  },
  "taxpayer-unsuscribe-request": {
    "title": {
      "page": "Qeydsizlər"
    }
  },
  "taxpayer-notification": {
    "title": {
      "sendMessagePage": "İsmarış yolla"
    },
    "label": {
      "nit": "TIN",
      "taxpayerName": "Ad",
      "subject": "Mövzu",
      "message": "İsmarış:"
    }
  },
  "appMenu": {
    "audit-log-application-http": "Tətbiq http jurnalı",
    "audit-log-security-http": "Təhlükəsizlik http jurnalı",
    "catalog": "Kataloqlar",
    "collection_compliance": "Toplama və Uyğunluq",
    "collection_statistics": "Kolleksiya Statistikası",
    "compliance_statistics": "Uyğunluq Statistikası",
    "configuration": "Parametrlər",
    "configure_penalties": "Cərimələrin konfiqurasiyası",
    "debt_collection_manage": "Proseslərə baxın",
    "disable-tfa-to-user": "İki faktorlu identifikasiyanı (2FA) deaktiv edin",
    "economy-activity": "Əməliyyatlar",
    "environment-application": "Tətbiq dəyişənləri",
    "environment-security": "Təhlükəsizlik dəyişənləri",
    "home-template": "Ev Şablonu",
    "manage-form": "Formalar",
    "manage-report-operations": "Əlavə Hesabatlar Əməliyyatları",
    "manage-report": "Əlavə Hesabatlar",
    "manage-tax-operations": "Vergi əməliyyatları",
    "manage-tax": "Vergilər",
    "management-report-payment": "Ödənişlər",
    "management-report-taxpayer": "Vergi ödəyiciləri",
    "management-report-taxreturn": "Vergi bəyannamələri",
    "management-report": "İdarəetmə Hesabatları",
    "non_compliance": "Uyğunsuzluğa nəzarət",
    "notifications-application": "Tətbiq Bildirişləri",
    "notifications-security": "Təhlükəsizlik Bildirişləri",
    "operations": "Əməliyyatlar",
    "query-payments-taxofficer": "Ödənişlərin siyahısı",
    "report-details": "Əlavə Hesabatları Siyahıya salın",
    "reports": "Vergi bəyannamələri",
    "security": "Təhlükəsizlik",
    "send-message-taxpayer": "Mesaj göndər",
    "statements-tax-officer": "Vergi bəyannamələri",
    "tax-official-query-amending-credit": "cari hesab",
    "taxes": "Vergilər",
    "taxofficer-check-load-payments": "Bank məlumatlarını yoxlayın",
    "taxofficer-payment-record": "Ödəniş qeydi",
    "taxofficer-reconciliation-payments": "Ödənişlərin uzlaşdırılması",
    "taxofficer-taxreturn-payments": "Ödənişlər",
    "taxofficer-transaction-adjustment": "Balans tənzimlənməsi",
    "taxofficer-upload-payments": "Bank məlumatları yüklənir",
    "taxpayer-feedback": "Əlaqə",
    "taxpayer-fields": "Vergi ödəyicisi sahələri",
    "taxpayer-report": "Vergi ödəyicilərinin siyahısı",
    "taxpayer-requests": "Vergi Ödəyicisinin Müraciətləri",
    "taxpayers": "Vergi ödəyiciləri",
    "taxreport-report": "Vergi bəyannamələrinin siyahısı",
    "taxreturn-evaluation": "Düzəlişlərə yenidən baxılması",
    "terms-template": "Qaydalar və şərtlər Şablonu",
    "two-factor-authentication": "İki faktorlu autentifikasiya",
    "user-taxpayers": "Vergi ödəyiciləri",
    "users": "İstifadəçilər"
  }
}
